angular.module('forms').directive('apFormQuestionPatientProblemHistory',[
        '$q',
        '$rootScope',
        'FormsId',
        'FormsService',
        'ListService',
        function (
            $q,
            $rootScope,
            FormsId,
            FormsService,
            ListService
            ) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormQuestionPatientProblemHistory.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    questionnaireSectionId: '=questionnaireSectionId',
                    questionnaireSection: '=questionnaireSection',
                    loading: '=loading'
                },
                controller: function($scope) {
                    $scope.findTableItemsProblemHx = '';
                    $scope.currentSectionId = '';

                    $scope.$watch('questionnaireSectionId', function() {
                        if ($scope.currentSectionId === '') {
                            return;
                        }

                        if ($scope.currentSectionId !== $scope.questionnaireSectionId) {
                            loadView();
                        }
                    });


                    function getFindTableItemsProblemHx(subFindTableId) {
                        return ListService.getList('subfindtableitems/patient-history-problem/' + subFindTableId)
                            .then(function (data) {
                                $scope.findTableItemsProblemHx = data;

                                if ($scope.questionnaireSection.ProblemHistoryAnswers.length <= 0) {
                                    _.forEach($scope.findTableItemsProblemHx, function(findTableItem) {
                                        $scope.questionnaireSection.ProblemHistoryAnswers
                                            .push(FormsService.getNewProblemHistoryAnswer(
                                                findTableItem.SubFindTableItemId,              // PK for SubFindTableItem table
                                                $scope.questionnaireSection.HistoryGroupId,
                                                findTableItem.ItemId,                          // diseaseId
                                                findTableItem.Name));                          // disease name
                                    });
                                }
                            });
                    }


                    function loadView() {
                        $rootScope.setupDirectiveScope($scope);
                        $scope.removeHttpError();
                        var findTableItemsProblemHxPromise = getFindTableItemsProblemHx($scope.questionnaireSection.ProblemHxSubFindTableId);

                        $q.all([findTableItemsProblemHxPromise]).then(function () {
                            $scope.currentSectionId = $scope.questionnaireSectionId;
                        }).catch(function (response) {
                            $scope.addHttpError(response, '', 'listData');
                        }).finally(function () {
                            $scope.loading = false;
                        });
                    }
                    loadView();


                    $scope.timeFrameSelectedCallback = function timeFrameSelectedCallback(timeFrameId, onsetTimeFrameId) {
                        var problemHistoryAnswer = _.find($scope.questionnaireSection.ProblemHistoryAnswers, {ProblemHistoryAnswerId: timeFrameId});
                        if (problemHistoryAnswer) {
                            if ((onsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Clear) || (onsetTimeFrameId === '')) {
                                problemHistoryAnswer.Selected = false;
                                problemHistoryAnswer.Notes = '';
                            } else {
                                problemHistoryAnswer.Selected = true;
                            }
                        }
                    };

                }
            };
        }
    ]
);